const WebsiteSetting = ({
  state: {
    website_setting_keys: [],
  },
  mutations: {
    SET_WEBSITE_SETTING_KEYS: (state, data) => {
      state.website_setting_keys = data;
    }
  },
  actions: {
    SET_WEBSITE_SETTING_KEYS: ({commit}, data) => {
      commit('SET_WEBSITE_SETTING_KEYS', data);
    },
  },
  getters: {
    GET_WEBSITE_SETTING_KEYS: state => state.website_setting_keys,
  }
});

export default WebsiteSetting;
